"use client";

import { useMutation } from "@tanstack/react-query";
import { trackEvent } from "@/analytics";
import { logException } from "@/analytics/sentry";

interface HideSpecialParams {
  specialId: string;
  location?: string;
  postId?: string;
  onHide?: (postId: string) => void;
}

export function useHideSpecial() {
  const mutation = useMutation({
    mutationFn: async ({
      specialId,
      location,
      postId,
      onHide,
    }: HideSpecialParams) => {
      const res = await fetch(`/api/v2/user/hidden-specials/${specialId}`, {
        method: "POST",
      });

      if (!res.ok) {
        throw new Error(`Failed to hide special: ${res.statusText}`);
      }

      trackEvent("FEED_HIDE_SPECIAL", {
        special_id: specialId,
        location,
      });

      if (postId && onHide) {
        onHide(postId);
      }

      return res;
    },
    onError: (error, variables) => {
      logException(error, {
        extra: {
          message: "Error hiding special",
          specialId: variables.specialId,
          location: variables.location,
        },
      });
      console.error("Failed to hide special", error);
    },
  });

  return {
    hideSpecial: mutation.mutate,
    hideSpecialAsync: mutation.mutateAsync,
    isHiding: mutation.isPending,
    error: mutation.error,
  };
}
